import Style from './container.module.scss';
import { useEditor, useNode } from '@craftjs/core';
import { useCallback, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { getCloneTree } from 'src/components/formEditor/uiEditor/uiEditor-helper';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { generateNestedDataKey } from 'src/features/generalForms/builder/layout/panels/helpers/helper';
import {
  FormRepeatableContainerComponent,
  FormRepeatableSection,
} from 'src/features/generalForms/builder/types/RepeatableContainer';

export const RepeatableContainer: FormRepeatableContainerComponent = ({ dataKey: rootDataKey, children, title }) => {
  const { actions, query } = useEditor();
  const { visible } = useAnswerRowConditional();

  const { node: parentNode } = useNode((n) => ({
    styles: n.data.custom,
    node: n,
  }));

  const form = useFormContext();
  const fieldOrder = useWatch({ control: form.control, name: `${rootDataKey!}.order` }) ?? [];
  const addSection = useCallback(
    (sectionDataKey: string) => {
      const newTree = getCloneTree(query, parentNode.data.linkedNodes.id, generateNestedDataKey(query, sectionDataKey));
      actions.addNodeTree(newTree, parentNode.id);
    },
    [actions, parentNode.data.linkedNodes.id, parentNode.id, query],
  );

  useEffect(() => {
    // IMPORTANT: There will be a slight delay to allow Craft.js to load ROOT.
    const timer = setTimeout(() => {
      parentNode.data.nodes.forEach((nodeId) => actions.delete(nodeId));
      fieldOrder.forEach(addSection);
    }, 0);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldOrder]);

  if (!visible) {
    return <></>;
  }

  return (
    <div className={Style.repeatableContainer}>
      {title && (
        <div className={Style.title}>
          <p>{title}</p>
        </div>
      )}
      {children}
    </div>
  );
};

export const RepeatableSection: FormRepeatableSection = ({ children }) => {
  return <div className={Style.section}>{children}</div>;
};
